import { Avatar, HStack, Text, BoxProps } from '@chakra-ui/react'
import React from 'react'
import { formatsToUrl } from '../utils/image'

interface Props extends BoxProps {
  name: string
  profileImage: any
}
export default function MusicianAvatarName({ name, profileImage, ...restProps }: Props) {
  return (
    <HStack {...restProps}>
      <Avatar name={name} src={formatsToUrl(profileImage?.formats) ?? '/images/animal_music_band.png'} />
      <Text>{name}</Text>
    </HStack>
  )
}
